import colors from '../colors';
export var MuiTableSortLabel = {
    root: {
        whiteSpace: 'nowrap',
        '&.Mui-active': {
            '& .MuiTableSortLabel-iconDirectionAsc [data-sort-icon=asc]': {
                borderBottomColor: colors.blue['700'],
            },
            '& .MuiTableSortLabel-iconDirectionDesc [data-sort-icon=desc]': {
                borderTopColor: colors.blue['700'],
            },
        },
        '&:hover, &[class*=focusVisible]': {
            color: 'inherit',
            opacity: 0.75,
            '& div.MuiTableSortLabel-icon': {
                opacity: 1,
            },
        },
    },
};
//# sourceMappingURL=TableSortLabel.js.map